import React, { ReactNode } from 'react';
import { AlertProvider } from './alert_provider';
import { ConfirmProvider } from './confirm_provider';

export const PopupProvider = ({ children }: { children: ReactNode }) => {
  return (
    <AlertProvider>
      <ConfirmProvider>{children}</ConfirmProvider>
    </AlertProvider>
  );
};
